<template>
  <div>
    <!-- <div v-if="this.$root.page_loader" class="home">
			<div
				style="background-color: rgba(255,255,255,1);"
				id="r_page_loader"
				v-show="this.$root.page_loader == true"
			>
				<PuSkeleton style="width:100%;height:500px" />

				<div class="category m-5" id="category">
					<h2 class="headingPrimary pt-0 pb-3">
						<PuSkeleton />
					</h2>
					<ul class="sortLink">
						<li class="link tagLinks" v-for="(item, i) in 5" :key="i">
							<PuSkeleton />
						</li>
						<li class="link tagLinks">
							<PuSkeleton />
						</li>
					</ul>
				</div>

				<div class="m-5" style="display:flex;justify-content:'space-around'">
					<div style="width:25%;height:300px;margin:5px" v-for="(item, index) in 5" :key="index">
						<PuSkeleton style="width:25%;height:300px" />
					</div>
				</div>
				<div class="m-5" style="display:flex;justify-content:'space-between';margin-top:20px">
					<div style="width:25%;height:300px;margin:5px" v-for="(item, index) in 5" :key="index">
						<PuSkeleton style="width:25%;height:300px" />
					</div>
				</div>

				
			</div>
		</div> -->
     <div class="only-mobile">
       <ul>
        <li v-for="menu in topBarMenu" :key="menu.position">
          
          <router-link :to="'/category/' + menu.url_key + '.html'">
            <img class="img-fluid" :src="menu.image? menu.image: `/img/thumbnail.jpg`"/>
            <h3> {{ (menu.name).replace("and", "&") }}</h3> 
          </router-link>
        </li> 
      </ul>  
       </div>
    <div class="home">
      <PuSkeleton
        v-if="this.slider.length == 0"
        style="width: 100%; height: 450px"
      />
      <Banner v-else :slider="slider" />
      <div id="fillSpace"></div>
      <div class="category" v-if="Object.keys(nearestBrands).length == 0">
        <PuSkeleton style="width: 100%; height: 150px" />
      </div>
      <div class="category" v-else id="category">
        <h2 class="headingPrimary pt-0 pb-3">
          <span>WNDW</span>
          to {{ this.$root.cityName }}
        </h2>
        <ul class="sortLink">
          <li
            class="link tagLinks"
            v-for="(item, i) in this.nearestBrands"
            :key="i"
          >
            <a
              :class="{ 'router-link-active': i == sectionActive }"
              @click="sectionActive = i"
              :href="`#${item.id}`"
              :name="`${item.name}`"
              :data-id="item.id"
              >{{ item.name }}</a
            >
          </li>
          <li class="link tagLinks">
           <a href="#All" name="All" data-id="All">All Stores</a>
          </li>
        </ul>
      </div>
      <div
        v-if="Object.keys(nearestBrands).length == 0"
        class="brandBox"
        style="background: #fff"
      >
        <div class="m-5" style="display: flex; justify-content: 'space-around'">
          <div
            style="width: 20%; height: 300px; margin: 5px"
            v-for="(item, index) in 5"
            :key="index"
          >
            <PuSkeleton style="width: 25%; height: 300px" />
          </div>
        </div>
        <div
          class="m-5"
          style="
            display: flex;
            justify-content: 'space-between';
            margin-top: 20px;
          "
        >
          <div
            style="width: 20%; height: 300px; margin: 5px"
            v-for="(item, index) in 5"
            :key="index"
          >
            <PuSkeleton style="width: 25%; height: 300px" />
          </div>
        </div>
      </div>
      <!-- <div class="brandBox" v-if="Object.keys(nearestBrands).length==0">
			<PuSkeleton v-for="(item, i) in 5" :key="i" style="width:20%;height:150px;margin:6px" />
			</div> -->

      <section
        v-else
        :id="item.id"
        v-for="(item, i) in this.nearestBrands"
        :key="i"
        class="brandBox"
      >
        <!-- <h2 v-if="i==0"  class="headingPrimary"></h2> -->
        <h2 class="headingPrimary">{{ item.name }}</h2>
        <Brand :brands="item.brands" />
        <section id="banner" class="row" v-if="i === 2">
          <div
            v-for="(item, index) in midBanner"
            :key="index"
            :class="{
              'col-md-6': midBanner.length == 2,
              'col-md-12': midBanner.length == 1,
            }"
          >
            <router-link to="/">
              <img
                class="img-fluid banner"
                :src="`${$root.image_url_c}inside/900x450/${item.image}`"
              />
              <!-- <ResponsiveImage
              v-bind:image="{
                desktop: '/psm-images/Under-999.jpg',
                tab: '/psm-images/Under-999.jpg',
                default_image: '/psm-images/Under-999.jpg',
              }"
              v-bind:desktop="this.$root.midBanner[0].image+ 'cover/150x150/'"
              v-bind:tab="this.$root.midBanner[0].image + 'cover/100x100/filters:quality(70)/'"
              v-bind:default_image="this.$root.midBanner[0].image + 'cover/300x300/'"
              v-bind:custom_width="'100%'"
							/>-->
            </router-link>
          </div>
          <!-- <router-link to="/" class="col-md-6">
						<img
						class="img-fluid banner"
						:src="`${$root.image_url_c}inside/900x450/${$root.midBanner[0].image}`"
						/>
             		</router-link>-->
        </section>
      </section>
      <section>
        <div class="Slider brandBox bottombanner">
          <slick ref="slicktwo" :options="slickOptions">
            <Slider v-for="(item, i) in bottomBanner" :key="i" :item="item" />
          </slick>
        </div>
      </section>
      <section class="nearby" id="nearby">
        <div class="section" id="All">
          <!-- <h4 class="headingPrimary">nearby stores</h4> -->
          <div class="sort">
            <div class="right">
              <!-- <h2 class="font-bold storeCount forDesktop" v-if="nearestStores">
                {{ nearestStores.length }}
                 Brands
							</h2>-->
							<ul class="filters">
								<li class="filter" @click="removeAllFilters" :class="{ active: isAll }">All Stores</li>
								<li
									:class="`filter ${activeBrand == name.id_category ? 'active' : ''}`"
									@click="addStoreFilterMain(name.id_category, true)"
									v-for="(name, i) in this.$root.menu"
									:key="i"
								>{{ name.name.replace("and", "&") }}</li>
							</ul>
							<p class="storeFilter" @click="isFilter = true">
								<img src="/img/storeFilter.png" alt /> Filters
							</p>
						</div>
					</div>
					<div class="storeLoader" v-if="storeLoader == true">
						<loading-icon class="loading-icon" name="ball-clip-rotate-multiple" color="#fff" scale="1"></loading-icon>
					</div>
					<div class="cardGrid row" v-if="nearestStores">
						<!-- .slice(0, itemsToShow) -->
						<!-- :to="{ path: '/store.html', query: { store: item.id } }" -->
						<div
							class="col-md-3 col-sm-4 col-4 small-3"
							v-for="(item, i) in nearestStores"
							:key="i"
							@click="storePopUpHandler(item.all_stores)"
						>
							<Card v-if="i < 8 || !isViewMore" :item="item" />
						</div>
					</div>
					<div v-if="nearestStores.length == 0" class="storeBlank text-center">
						<!-- <img src="/img/wndw_coming_soon.png" alt=""> -->
						<h3 class="text-white">Coming Soon...</h3>
					</div>
				</div>
				<div class="moreStore" v-if="isViewMore && nearestStores.length > 8">
					<button class="moreStoreBtn" @click="itemstoShowHandler">View All</button>
					<i class="ml-2 pt-2 fa fa-angle-down" aria-hidden="true"></i>
				</div>
				<div class="moreStore" v-if="!isViewMore">
					<button class="moreStoreBtn" @click="isViewMore = true">View Less</button>
					<i class="ml-2 pt-2 fa fa-angle-up" aria-hidden="true"></i>
				</div>
			</section>
			<div class="rightFilterWrap" :class="{ showFilter: isFilter }">
				<div class="rightFiterContent">
					<div class="filterHeading">
						<p class="float-left mr-3 text-dark cursorPointer" @click="isFilter = false">&#10005;</p>Store Product Filter
					</div>
					<div class="filterData">
						<div class="filterDataScroll">
							<div id="accordion" class="accordion-container">
								<div class="accordionWrap" v-for="(filter, i) in this.$root.menu" :key="i">
									<h4
										class="accordion-title"
										:class="{ open: i == selectedAccorion }"
										@click="accordianChange(i)"
									>{{ filter.name }}</h4>
									<div
										class="accordion-content"
										:class="{ showAccordion: i == selectedAccorion }"
										v-if="filter.childs"
									>
										<div v-for="(childs, h) in filter.childs" :key="h">
											<strong class="filterSubHeading d-inline-block w-100">{{ childs.name }}</strong>
											<div v-if="childs.childs">
												<div
													@click="addStoreFilter(sub.id_category)"
													class="filterDiv"
													:class="{
                            filterSelected: appliedFilters.includes(
                              sub.id_category
                            ),
                          }"
                          v-for="(sub, h) in childs.childs"
                          :key="h"
                        >
                          <span>{{ sub.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="filterButton">
              <button class="sideFilterMore" @click="getStores()">
                See Stores
              </button>
              <button class="sideFilterClear" @click="removeAllFilters">
                Clear List
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      v-bind:class="{ active: isStorePopUp === true }"
      id="coupon-modal"
      v-if="isStorePopUp"
    >
      <div class="modal-dialog listStorePopup">
        <div class="modal-content">
          <div class="modal-body">
            <!-- class="close" -->
            <button
              type="button"
              class="close"
              @click="isStorePopUp = false"
              style="
                margin-top: 0px;
                margin-right: 15px;
                z-index: 999;
                top: 15px;
                right: 0px;
                font-size: 25px;
              "
            >
              &times;
            </button>
            <div>
              <div class="storePopupHeading">
                <h3>
                  {{ popUpStores[0].name.replace(/"/g, "").split(",")[0] }}
                </h3>
                <small>{{ popUpStores.length }} Stores near you</small>
              </div>
              <div class="storeWrap">
                <div class="row storePopupDetail">
                  <div class="col-7">
                    <strong>Address</strong>
                  </div>
                  <!-- <div class="col-2">
                    <strong>Close/Open</strong>
                  </div> -->
                  <div class="col-2">
                    <strong>Rating</strong>
                  </div>
                  <div class="col-3">
                    <strong>Distance</strong>
                  </div>
                </div>
                <div
                  class="row storePopupData"
                  v-for="(store, i) in popUpStores"
                  :key="i"
                >
                  <router-link
                    class="col-7 popuplink"
                    :to="{ path: '/store.html', query: { store: store.id } }"
                  >
                    <div style="display: flex; justify-content: space-between">
                      {{
                        store.name
                          .replace(/"/g, "")
                          .substring(store.name.indexOf(",") + 1)
                      }}
                      <img
                        v-if="store.express_store.is_express_delivery_available"
                        height="25"
                        src="/img/expressDelivery.png"
                        alt="Express Delivery"
                      />

                      <img
                        v-if="store.express_store.is_express_delivery_available==false && store.temp_store_close==1"
                       
                        height="25"
                        src="/img/store-closed-icon.png"
                        alt="Express Delivery"
                      />
          
                    </div>
                  </router-link>
                  
                   <!-- <div v-if="store.temp_store_close==1" class="col-2">Closed</div>
                   <div v-else class="col-2">Open</div> -->
                  <div class="col-2">
                    <i class="fa fa-star"></i>
                    {{ store.ratings.avg_rating }}
                  </div>
                  <div class="col-3">{{ Math.floor(store.distance) }} km</div>
                </div>
              </div>
            </div>
            <!-- <div v-for="(store, i) in popUpStores" :key="i">
              {{ store.name }}
						</div>-->
          </div>

          <!-- <Login /> -->
        </div>
      </div>
    </div>

    <!-- for mobile trandign setion model -->
    <div
      class="modal"
      v-bind:class="{ active: $root.isStorePopUpMobile == true }"
      id="coupon-modal"
      v-if="$root.isStorePopUpMobile"
    >
      <div class="modal-dialog listStorePopup coupan-modal-one">
        <div class="modal-content" >
          <div class="modal-body">
            <!-- class="close" -->
            <button
              type="button"
              class="close"
              @click="$root.isStorePopUpMobile = false"
              style="
                margin-top: 0px;
                margin-right: 15px;
                z-index: 999;
                top: 15px;
                right: 0px;
                font-size: 25px;
              "
            >
              &times;
            </button>
            <div>
              <div class="storePopupHeading">
                <h3>
                  {{
                    $root.popUpStoresMobile[0].name
                      .replace(/"/g, "")
                      .split(",")[0]
                  }}
                </h3>
                <small
                  >{{ $root.popUpStoresMobile.length }} Stores near you</small
                >
              </div>
              <div class="storeWrap" @click="$root.isStorePopUpMobile = false">
                <div class="row storePopupDetail">
                  <div class="col-7">
                    <strong>Address</strong>
                  </div>
                  <div class="col-2">
                    <strong>Rating</strong>
                  </div>
                  <div class="col-3">
                    <strong>Distance</strong>
                  </div>
                </div>
                <div
                  class="row storePopupData"
                  v-for="(store, i) in $root.popUpStoresMobile"
                  :key="i"
                >
                  <router-link
                    class="col-7 popuplink"
                    :to="{ path: '/store.html', query: { store: store.id } }"
                  >
                    <div>
                      {{
                        store.name
                          .replace(/"/g, "")
                          .substring(store.name.indexOf(",") + 1)
                      }}
                    </div>
                  </router-link>
                  <div class="col-2">
                    <i class="fa fa-star"></i>
                    {{ store.ratings.avg_rating }}
                  </div>
                  <div class="col-3">{{ Math.floor(store.distance) }} km</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- for mobile trandign setion model end -->
  </div>
</template>
<style>
@import "../../../node_modules/slick-carousel/slick/slick.css";
/* .slick-dots li.slick-active button:before{
					  color: red;
					  /* background: red; */
/* } */
.bottombanner{
  display: flex;
  justify-content: center;
}
.filterSubHeading {
  font-size: 13px;
  text-transform: capitalize;
  font-family: "lhmRegular";
}
.filterCheck {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  display: inline-block;
  margin-right: 8px;
  border-radius: 5px;
  margin-bottom: -6px;
  line-height: 19px;
  text-align: center;
  font-size: 14px;
  color: #ccc;
}
.filterCheck.activeFiterHeader {
  color: #fff;
  border: 1px solid var(--main-color);
  background-color: var(--main-color);
}
.accordion-container .accordion-title {
  position: relative;
  margin: 0;
  padding: 15px 15px;
  font-size: 16px;
  font-family: "lhmSemiBold";
  cursor: pointer;
  display: inline-block;
  width: 100%;
}

.accordion-container .accordion-title::after {
  content: "\002B";
  font-size: 22px;
  color: var(--main-color);
  position: absolute;
  right: 10px;
  top: 15px;
}
.accordion-container .accordion-title.open::after {
  content: "\2212";
  font-size: 22px;
  color: var(--main-color);
  position: absolute;
  right: 10px;
  top: 15px;
}

.accordion-content {
  padding: 10px 15px;
  display: none;
  background-color: #f7f9fb;
}
.accordion-content.showAccordion {
  display: flow-root;
}

.sticky {
  position: sticky;
  top: 0;
  width: 100%;
  animation: fadeIn 0.5s ease-in both;
  /* box-shadow: 0px 3px 6px 0px rgba(0,0,0,.05); */
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate3d(0, -20%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.storeFilter {
  position: absolute;
  right: 25px;
  top: 10px;
  font-size: var(--font-size-regular);
  font-family: "lhmRegular";
  line-height: 25px;
  text-transform: capitalize;
  margin-bottom: 0;
  cursor: pointer;
  color: #fff;
  border-left: 1px solid #ffffff4d;
}
.storeFilter img {
  margin: 0 5px 0px 15px;
  width: 12px;
}

.Slider .slick-list.draggable {
  height: auto !important;
}
.banner {
  width: 100%;
  margin: 5% 0px;
  height: auto;
  /* padding: 0px 15px; */
}
.home {
  background: #eeeeee;
  /* margin-top: -12px; */
}
.brandBox {
  background: #eeeeee;
  overflow: hidden;
  padding: 0px 6rem 3rem 6rem;
}
.nearby {
  background: #000;
  overflow: hidden;
  padding-bottom: 2rem;
  /* margin-top: 20px; */
}
.nearby > .section > h4 {
  color: #a2a2a2 !important;
}
.section {
  /* width: 80%; */
  margin: 90px 200px;
}
.moreStore {
  text-align: center;
  color: #eeeeee;
  box-sizing: border-box;
  position: relative;
}
.moreStore i {
  font-size: 20px;
  position: absolute;
  top: -2px;
}

.moreStoreBtn {
  display: inline-block;
  background: none;
  border: none;
  color: #eeeeee;
  font-family: "lhmRegular";
  font-size: var(--font-size-regular);
  line-height: 15px;
  padding: 0;
  border-bottom: 1px solid #eeeeee;
  text-transform: uppercase;
  cursor: pointer;
}
/* .moreStore::after{
					  content: '';
					  width: 0; 
					  height: 0; 
					  border-left: 10px solid transparent;
					  border-right: 10px solid transparent;
					  position: absolute;
					  top: 15px;
					  border-top: 10px solid #eeeeee; */
/* } */
.category {
  /* margin: 34px 0px; */
  padding: 34px 34px 24px 34px;
  background: #f7f7f7;
  /* scroll-snap-align: start;
					  scroll-snap-stop: normal; */
  /* transition: all .10s ease-in-out; */
}
#banner .router-link-active {
  padding: 0px !important;
}
a.w-100.router-link-exact-active.router-link-active {
  padding-bottom: 0px;
  background: none;
  padding: 0px;
}
.category > ul {
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding-left: 0px;
  align-items: center;
  margin-right: 10%;
  margin-left: 10%;
  /* float: none; */
}
/* .category > ul > li {
					  padding: 1rem 2rem;
					} */
.category > ul > li:active {
  /* padding: 1rem 2rem; */
  background: #eeeeee;
}
.category > ul > li:hover {
  /* padding: 1rem 2rem; */
  /* background: #eeeeee; */
  cursor: pointer;
}

.headingPrimary {
  /* text-transform: capitalize; */
  text-align: center;
  line-height: 48px;
  font-size: 28px;
  padding-bottom: 10px;
  font-family: "lhmBold";
  padding-top: 1.5rem;
  /* padding-top: 10px; */
}
.moreLinks:hover {
  text-decoration: none;
  color: black;
}
.cardGrid {
  /* display: flex;
					  flex:0 0 25%;
					  flex-wrap: wrap; */
  margin-top: 50px;
  /* justify-content: center; */
  padding: 0px 10%;
}
.sort {
  margin: 0px;
  padding: 0px;
}
.category.sticky {
  padding: 12px 6px !important;
  background-color: #eeeeee;
  z-index: 1;
  position: sticky;
  top: 66px;
  margin: 0px !important;
  width: 100%;
  margin: 0px !important;
  justify-content: space-around;
  padding: 0px;
  border-top: 0.25px solid #eeeeee;
}
/* .input.activeSearch:before {
				    content: '\f00d';
				    font-family: 'FontAwesome';
				    font-size: 20px;
				    /* font-family: 'fontello'; */
/* font-size: 24px; */
/* font-weight: 100; */
/* }  */
.fillSpace {
  height: 0px;
}
.category.sticky ~ .fillSpace {
  height: 100px;
}
.location.visible,
.icons.visible {
  margin-left: 30px !important;
  position: absolute;
  right: 20px;
  display: none;
}
.icons.visible > img:not(:last-child) {
  margin-right: 30px;
}
.slick-slide img:focus {
  outline: 0;
}
.category.sticky > .headingPrimary {
  display: none;
}
h1,
ul {
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
}
.category.sticky > ul {
  justify-content: space-around;
  align-items: center;
  padding: 0rem;
}

.sortLink .link {
  padding: 0px 0.5rem;
  /* margin-bottom: -3px; */
  font-size: var(--font-size-regular);
  line-height: 16px;
  white-space: nowrap;
  font-family: "lhmSemiBold";
}
.link > a {
  text-decoration: none;
  color: var(--font-dark-blue);
  padding: 1.2rem 1rem;
  font-family: "lhmRegular";
}
.tagLinks a {
  text-transform: uppercase;
  font-size: 13px;
}
.link > a.dropdownChild {
  text-transform: uppercase;
  font-size: 13px;
  color: #fff;
}
.link > a.dropdownChild:hover {
  color: #fff;
  font-weight: bold;
}
.link > a.dropdownChild:active {
  color: #fff;
  background-color: transparent;
}
.link > a:active {
  color: var(--main-color);
  background: #eeeeee;
  padding: 1.2rem 1rem;
}
.link.dropdownMenu > .router-link-active {
  color: #fff !important;
}
.link.dropdownMenu .router-link-active {
  color: #000;
  padding: 1.2rem 1rem;
  /* padding-bottom: 26px; */
  /* background: #eeeeee; */
  /* padding: .75rem 1rem; */
}
.category.sticky .router-link-active {
  padding-bottom: 11px;
  border-bottom: 1px solid var(--main-color);
  color: var(--main-color) !important;
}
.category.sticky .sortLink .link > a:hover {
  color: var(--main-color);
  padding-bottom: 11px;
  border-bottom: 1px solid var(--main-color);
}
.sortLink .link > a:hover {
  padding: 1.2rem 1rem;
}
.link > a:hover {
  color: var(--main-color);
  /* background: #eeeeee;
					 padding: .75rem 1rem; */
  /* padding-bottom: 26px;
					  /* background: none; */
  /* border-bottom: 1px solid red; */
}
.link > a:visited {
  text-decoration: none;
  /* decoration: none; */
}
.filters {
  list-style: none;
  display: flex;
  justify-content: center;
}

.filter {
  padding: 1.2rem 0.5rem;
  margin: 0px 10px;
  cursor: pointer;
  text-transform: capitalize;
  font-size: var(--font-size-regular);
  font-family: "lhmRegular";
  letter-spacing: 1.1px;
}
.sort .right .storeCount {
  position: absolute;
  left: 10px;
  top: 15px;
  font-size: var(--font-size-heading);
  font-weight: 700;
}
#nearby .sort {
  position: relative;
  background-color: #161616;
}

.Slider .slick-next {
  right: 30px !important;
  top: 60%;
  opacity: 1;
  background: none;
}
.slick-prev {
  left: -50px;
  opacity: 1;
}
.slick-next:before {
  content: url(/img/right.png) !important;
}
.Slider .slick-prev {
  left: 20px !important;
  top: 60%;
  opacity: 1;
  background: none;
}
.slick-prev:before {
  content: url(/img/left.png) !important;
  opacity: 1;
}
/* Responsive  */
.brandBox {
  background: #eeeeee;
  overflow: hidden;
  padding: 0px 0rem 0rem 0rem;
  padding-left: 5%;
  padding-right: 5%;
  /* padding-top: 3.5rem; */
}
/* .brandBox::before { 
					  display: block; 
					  content: " "; 
					  margin-top: -285px; 
					  height: 285px; 
					  visibility: hidden; 
					  pointer-events: none;
	        } */
@media screen and (max-width: 1024px) {
  .small-3 .card {
    width: 100% !important;
    min-height: auto !important;
  }
  .cardGrid .card {
    padding: 10px !important;
  }
  .filters {
    display: flex;
    justify-content: space-between;
    overflow-x: scroll;
    overflow-y: hidden;
    word-wrap: unset;
    white-space: nowrap;
    margin: 0px 150px;
  }
}
@media screen and (max-width: 767px) {
  .moreStore i {
    top: 1px;
  }
  .sortLink .link {
    padding: 4px 0.5rem;
    position: relative;
  }
  /* .slick-next , .slick-perv , .Slider
					   .slick-prev , .Slider .slick-next ,.slick-slider:hover .slick-prev 
					  ,.slick-slider:hover .slick-next {
					     */
  /* display: none !important; */
  /* } */
  /* .brandBox .headingPrimary {
					  display: none;
					} */
  .brandBox .headingPrimary {
    padding: 17px 0px;
  }
  .moreStore {
    text-align: center;
    color: #eeeeee;
    box-sizing: border-box;
    position: relative;
    border: 0.5px dashed #626262;
    margin: 10px;
    padding: 16px auto;
  }
  .moreStoreBtn {
    border-bottom: none;
    display: inline-block;
    background: none;
    border: none;
    color: #eeeeee;
    font-family: "lhmRegular";
    font-size: 14px;
    line-height: 34px;
    /* border-bottom: 1px solid #eeeeee; */
    cursor: pointer;
  }
  .moreStore::after {
    content: "";
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
    top: 15px;
    border-top: none;
  }

  .nearby > .section > h4 {
    color: #a2a2a2 !important;
    padding-bottom: 0px !important;
  }
  .link > a {
    color: var(--font-dark-blue);
  }
  .slick-next {
    position: absolute;
    right: 30px;
    opacity: 1;
  }
  .Slider .slick-next,
  .Slider .slick-prev {
    display: none !important;
  }
  .category {
    margin: 0px;
    padding: 7px !important;
  }
  .link {
    margin-left: 20px;
    font-size: 16px;
    line-height: 24px;
    /* border-bottom: 1px solid #EE1010; */
  }
  .link > a:active,
  a:hover,
  a:focus {
    color: var(--main-color);
    /* border-bottom: 6px solid red; */
  }
  .category > ul {
    margin-right: 0px;
    margin-left: -40px;
    overflow-x: scroll;
    overflow-y: hidden;
  }
  .category.sticky {
    display: none;
    position: relative;
    z-index: 0;
  }
  .sticky {
    position: none;
    width: 100%;
  }
  .headingPrimary {
    font-size: 16px;
    padding-top: 0px;
    padding-bottom: 0px;
    /* margin:26px 22px; */
    font-weight: 600;

    line-height: 24px;
  }

  .banner {
    display: none;
  }
  .router-link-active {
    padding: 0px;
    background: none;
    padding-bottom: 3px;
    /* border-bottom: 1px solid red; */
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .cardGrid {
    margin-top: 10px;
    padding: 0px 15px !important;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .section {
    width: 100%;
    margin: 0px;
  }
  .sort,
  .filter {
    border: 0px;
  }
  .filters {
    justify-content: space-between;
    overflow-x: scroll;
    overflow-y: hidden;
    word-wrap: unset;
    white-space: nowrap;
    padding-left: 0;
    margin: 0%;
  }
  .brandBox.Slider .slick-next {
    right: 25px !important;
    top: 40%;
  }
  button.slick-arrow.slick-next {
    opacity: 1 !important;
  }
  .slick-prev {
    opacity: 1;
    left: -50px;
  }
  .slick-next:before {
    content: url(/img/right.png);
  }
  .brandBox.Slider .slick-prev {
    left: 0 !important;
    top: 40%;
    opacity: 1;
  }
  .slick-prev:before {
    content: url(/img/left.png);
  }

  .small-3 {
    padding: 0px 5px !important;
  }
  .small-3 .card {
    padding: 0px 5px !important;
    min-height: 123px !important;
  }
  .carddDistance {
    display: none !important;
  }
}

@media screen and (max-width: 400px) {
  .small-3 .card {
    width: 100%;
    max-width: 100px;
    min-width: 100px;
    min-height: 100px !important;
  }
}
</style>
<script>
	import Slick from "vue-slick";
	import Banner from "./Banner";
	import LinkBox from "./LinkBox";
	import Brand from "./Brand";
	import CardWithHover from "./CardWithHover";
	import Card from "./Card";
	import Slider from "./Slider";
	import axios from "axios";
	export default {
		name: "Home",
		components: {
			Slick,
			Banner,
			LinkBox,
			Brand,
			CardWithHover,
			Card,
			Slider
			// Slick
		},
		metaInfo: {
			title: "WNDW | From your favourite store to your door in 3 hours or less",
      meta:[
        {name: 'description', content: 'The one-stop shop for all your shopping needs, delivered in 3 hours or less. Buy Groceries, Electronics, Fashion, Beauty, Home, Pet Care, Gifting, and Medicines.'}
      ] 
		},
		data() {
			return {
				filteredStores: [],
				apiFilter: "",
        topBarMenu: [],
				appliedFilters: [],
				nearestStores: [],
				nearestBrands: {},
				itemsToShow: 8,
				selectedAccorion: -1,
        previouslySelected: -1,
				isStorePopUp: false,
				isAll: true,
				sectionActive: "",
				isViewMore: true,
				isFilter: false,
				popUpStores: [],
				id: null,
				slider: [],
				midBanner: [],
				bottomBanner: [],
				storeLoader: true,
				img: [
					"/_nuxt/assets/img/1_3.jpg",
					"/_nuxt/assets/img/1_2.jpg",
					"_nuxt/assets/img/1_4.jpg",
					"_nuxt/assets/img/1.jpg",
					"_nuxt/assets/img/1_2.jpg",
					"_nuxt/assets/img/1_3.jpg",
					"_nuxt/assets/img/1_4.jpg",
					"_nuxt/assets/img/1.jpg"
				],
				slickOptions: {
					// "accessibility": false,
					dots: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					adaptiveHeight: true,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								infinite: true,
								dots: false
							}
						},
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								initialSlide: 1,
								dots: true
							}
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								dots: true
							}
						}
					]
				}
			};
		},
		created() {
			this.$root.page_loader = true;
		},
		beforeMount() {
      this.pushnotification()

			this.getStoresData();
			// this.reverseGeocode();
			this.getStores();
      

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode == 27) {
        this.isStorePopUp = false;
      }
    });
  },
  unmounted() {
    document.removeEventListener("keyup");
  },
  mounted() {
    
    document.getElementById("pim_main").classList.remove("landingPage");
    this.get_banner();
    this.get_top_bar()
    // 	jQuery('body').on('click', '.faq_item_h4', function(){
    //      jQuery(this).siblings('.faq_item_p').toggle();
    //  });
    jQuery("body").on("click", ".tagLinks a", function () {
      // console.log(jQuery(".tagLinks"));
      var faqtab = jQuery(this).attr("data-id");

      //console.log(jQuery('#'+faqtab).position().top);
      jQuery("html, body").animate(
        { scrollTop: jQuery("#" + faqtab).position().top - 100 },
        100
      );

      //  jQuery('.tagLinks a').removeClass('active');
      //      jQuery(this).parents('.tagLinks a').addClass('active');
    });
    //  if ( document.location.href.indexOf('#return_exchange') > -1 ) {
    //     setTimeout(function(){
    //          jQuery('html, body').animate({scrollTop:jQuery('#return_exchange').position().top + 20}, 'slow');
    //     }, 500);
    // }

    jQuery.fn.isInViewport = function () {
      var elementTop = jQuery(this).offset().top;
      var elementBottom = elementTop + jQuery(this).outerHeight();

      var viewportTop = jQuery(window).scrollTop();
      var viewportBottom = viewportTop + 120;

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    jQuery(window).on("resize scroll", function () {
      jQuery(".brandBox").each(function () {
        var activeColor = jQuery(this).attr("id");
        if (jQuery(this).isInViewport()) {
          jQuery(".tagLinks").children("a").removeClass("router-link-active");
          jQuery('.tagLinks a[data-id="' + activeColor + '"]')
            .parents(".tagLinks")
            .children("a")
            .addClass("router-link-active");
        }
      });
    });
    // window.addEventListener('keyup', function(event) {
    //         // If  ESC key was pressed...
    //         if (event.keyCode === 27) {
    //           console.log("called");
    //             // try close your dialog
    //              this.isStorePopUp = false
    //         }
    // })

    window.addEventListener("scroll", function (e) {
      let filter = document.getElementById("category");
      // let fill = document.getElementById("fillSpace");
      if (filter) {
        // if (
        // 	document.body.scrollTop > 535 ||
        // 	document.documentElement.scrollTop > 535
        // ) {
        // 	// document.getElementById("fillSpace").style.height = "100px"
        // 	filter.classList.add("sticky");
        // } else {
        // 	//  document.getElementById("fillSpace").style.height = "0px"
        // 	filter.classList.remove("sticky");
        // }
      }
    });
  },
  computed: {
    activeBrand() {
      var array = this.apiFilter.split(",");

      let activeBrand = array[array.length - 1];
      if (!activeBrand) {
        this.isAll = true;
      } else {
        this.isAll = false;
      }
      return activeBrand;
    },
  },

		methods: {

      pushnotification(){
     

			 let pushtoken=  $cookies.get(
              window.location.hostname.substring(10, 4) + "_devicetoken"
            );
          let customerId=$cookies.get(
                  window.location.hostname.substring(10, 4) + "_customer"
                );
					let platform=$cookies.get(
              window.location.hostname.substring(10, 4) + "_platform"
            );
				var form = new FormData();
				form.append("fcm_device_token", pushtoken);
				form.append("customer_id", customerId);
        form.append("platform", platform);
				axios.post(`${this.$root.admin_api}/push-notification`,form)
				.then((res) => {
					console.log(res)
				})
				.catch((err) => {
					console.log(err)		
				});
      },
      accordianChange(i){
        this.selectedAccorion = i;
        if(this.selectedAccorion == this.previouslySelected){
          this.selectedAccorion = -1;
          this.previouslySelected = -1;
        } else{
          this.previouslySelected = i;
        }
      },
			get_banner() {
				axios
					.get(
						this.$root.api_url +
							`/pim/pimresponse.php?service=banner_slider&store=${this.$root.store}`
					)
					.then(response => {
						this.slider = response.data.result.mainbanner;
						this.midBanner = response.data.result.midbanner;
						this.bottomBanner = response.data.result.bottombanner;
						this.slider_show = true;
					});
			},
      get_top_bar() {
				axios
					.get(
						this.$root.api_url +
							`/pim/pimresponse.php?service=mobile_header_menu&store=${this.$root.store}`
					)
					.then(response => {
            this.topBarMenu = response.data.result;
					});
			},

    storePopUpHandler(stores) {
      // console.log("stores", stores);
      this.popUpStores = stores;
      this.isStorePopUp = true;
    },
    closeFilter() {
      this.isFilter = false;
    },
    removeAllFilters() {
      this.appliedFilters = [];
      this.apiFilter = "";
      this.isFilter = false;
      this.getStores();
    },
    addStoreFilterMain(id, isApply) {
      this.appliedFilters = [];
      this.apiFilter = [];
      this.appliedFilters.push(id);
      this.apiFilter = this.appliedFilters.join(",");

      if (isApply) {
        this.getStores();
      }
    },

    addStoreFilter(id, isApply) {
      if (this.appliedFilters.includes(id)) {
        let filtersApplied = this.arrayRemove(this.appliedFilters, id);
        this.appliedFilters = filtersApplied;
      } else {
        this.appliedFilters.push(id);
      }
      this.apiFilter = this.appliedFilters.join(",");
      if (isApply) {
        this.getStores();
      }

      // this.getStores()
    },
    arrayRemove(arr, value) {
      return arr.filter(function (ele) {
        return ele != value;
      });
    },

    getStores() {
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "category_stores",

            categories: this.apiFilter,

            // latitude: 28.5758268,
            // longitude: 77.3209443,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
          },
        })
        .then((response) => {
          if (!response.data.result) {
            this.nearestStores = [];
            this.isFilter = false;
          }
          let stores = response.data.result;
          // console.log("storeoasudoasud", stores);
          // for (let k = 0; k < stores.length; k++) {
          // 	// console.log("stiredadd", stores[k]);
          // 	// console.log(stores[k]);
          // 	// for (let j = 0; j < stores[k].stores.length; j++) {
          // 	// console.log(stores[k].stores[j]);
          // 	let distance = this.getDistanceFromLatLonInKm(
          // 		this.$root.location.lat,
          // 		this.$root.location.long,
          //
          // 		// position.coords.latitude,
          // 		// position.coords.longitude,
          // 		stores[k].latitude,
          // 		stores[k].longitude
          // 	);
          // 	stores[k].distance = distance.toFixed(2);
          // 	if (stores[k].all_stores) {
          // 		stores[k].all_stores.map((store, i) => {
          // 			//   console.log(store);
          // 			let distance = this.getDistanceFromLatLonInKm(
          // 				this.$root.location.lat,
          // 				this.$root.location.long,
          // 				// position.coords.latitude,
          // 				// position.coords.longitude,
          // 				store.latitude,
          // 				store.longitude
          // 			);
          //
          // 			store.distance = distance.toFixed(2);
          // 		});
          // 	}
          //
          // 	// }
          // }
          //   console.log(stores);
          this.nearestStores = stores;
          this.storeLoader = false;
          //   console.log("test",this.nearestStores);
          this.isFilter = false;
          // this.nearestStores = response.result
        })
        .catch((error) => {});
    },
    // reverseGeocode() {
    //   this.$root.page_loader = true;
    //   const that = this;
    //   axios
    //     .get(
    //       `https://maps.google.com/maps/api/geocode/json?latlng=${this.$root.location.lat},${this.$root.location.long}&key=AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc`
    //     )
    //     .then((response) => {
          // console.log(response.data);
          // let add = response.data.results[4].formatted_address.split(",");
          // this.$root.cityName = add[0];
          // add.shift();
          // this.$root.locationAddress = add.join(",");
          // response.data.results[0].address_components[1].short_name;

          // add.join()

    //       this.$root.page_loader = false;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     })
    //     .finally(() => (this.loading = false));
    // },
    itemstoShowHandler() {
      this.isViewMore = false;
    },
    getStore(id) {
      this.isViewMore = true;
      this.isAll = false;
      // this.id = id
      // this.nearestStores.map((store) => {
      // 	// console.log(store);
      // 	if (store.id === id) {
      // 		this.filteredStores = store;
      // 		this.id = store.id;
      // 	}
      // });
    },
    getAll() {
      this.isAll = true;
      this.id = null;
      let stores = [];
      // this.nearestStores.map((store) => {
      // 	//  console.log(store);
      // 	store.stores.map((str) => {
      // 		stores.push(str);
      // 	});
      // });
      //  console.log("called");

      this.filteredStores = { stores: stores };
    },
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1); // this.deg2rad below
      var dLon = this.deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
    },

			deg2rad(deg) {
				return deg * (Math.PI / 180);
			},
			getStoresData() {
				this.$root.page_loader = true;
				axios
					.get(
						`${this.$root.api_url}/pim/get-nearby-data/${this.$root.location.lat}/${this.$root.location.long}`
					)
					.then(res => {
						let categories = res.data.tags;
						this.storeCount = res.data.storesCount;
						this.getAll();
						this.nearestBrands = categories;
            console.log("Nearest Brands", this.nearestBrands);
						this.$root.nearestCategories = categories;

          this.$root.page_loader = false;
          //  this.$store.dispatch('getBrands', categories)

          //  this.getStore(1)
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>